module.exports = __webpack_public_path__ + "img/menu2-it.80d9ccac.jpg";